var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page --incompatible" }, [
    _c("div", { staticClass: "content" }, [
      _c("h1", [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.__("That didn't work:", "bluehost-site-migrator"))
        ),
        _c("br"),
        _vm._v(
          "\n\t\t\t" +
            _vm._s(
              _vm.__("Let's bring in the pros.", "bluehost-site-migrator")
            ) +
            "\n\t\t"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(
              _vm.__(
                "This can happen if you have a multisite, alternate directory structures, or certain themes or plugins. The transfer might require some extra steps, or we might need to look at other options.",
                "bluehost-site-migrator"
              )
            ) +
            "\n\t\t"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.__("Give us a call at 888-401-4678.", "bluehost-site-migrator")
          )
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("img", { attrs: { src: _vm.imageSrc } }),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }